module.exports = __webpack_public_path__ + "img/copy.14be54bc.svg";